import * as React from "react";
import IconSmall from "../../hiberUiKit/src/atoms/Icon/IconSmall";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import "./deepLinkLinks.scss"

interface Props {
	onUniversalDeeplinkClick: () => void;
	onAppDeeplinkClick: () => void
}

interface State {
	universalDeeplinkTooltipVisible: boolean
	appDeeplinkTooltipVisible: boolean
}

export default class DeepLinkLinks extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {universalDeeplinkTooltipVisible: false, appDeeplinkTooltipVisible: false}
	}

	render() {
		return (
			<div className={"c-deeplink-links"}>
				<div className={"circle-wrapper l-circle-wrapper"}
					 onClick={this.props.onUniversalDeeplinkClick}
					 onMouseOver={() => {this.setState({universalDeeplinkTooltipVisible: true})}}
					 onMouseOut={() => {this.setState({universalDeeplinkTooltipVisible: false})}}>
					<IconSmall icon={Icon.Link}
							   variant={"white"}
							   iconTooltipText={"Copy universal mobile app deep-link"}/>
					{this.state.universalDeeplinkTooltipVisible && <div className={"c-deeplink-links_tooltip"}>
						<div>Copy universal deeplink</div>
						<div>WORKS via emails, sms, etc.</div>
						<div>DOES NOT work via Intercom</div>
					</div>}
				</div>
				<div className={"circle-wrapper l-circle-wrapper"} onClick={this.props.onAppDeeplinkClick}
					 onMouseOver={() => {this.setState({appDeeplinkTooltipVisible: true})}}
					 onMouseOut={() => {this.setState({appDeeplinkTooltipVisible: false})}}>
					<IconSmall icon={Icon.Link}
							   variant={"white"}
							   iconTooltipText={"Copy mobile app deep-link"}/>
					{this.state.appDeeplinkTooltipVisible && <div className={"c-deeplink-links_tooltip"}>
						<div>Copy app deeplink</div>
						<div>WORKS via Intercom</div>
					</div>}
				</div>
			</div>
		)
	}
}